import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from "../axios";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import AddIcon from "@mui/icons-material/Add";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useMediaQuery } from "@mui/material";

export const Price = () => {
  const [prices, setPrices] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [newPrice, setNewPrice] = useState({});
  const { data: user } = useSelector((state) => state.auth);
  const isAdmin = user?.isAdmin;
  const isMobile = useMediaQuery("(max-width:600px)");

  const fetchPrices = async () => {
    try {
      const { data } = await axios.get("/prices");
      setPrices(data);
    } catch (err) {
      console.error("Помилка під час завантаження цін", err);
    }
  };

  useEffect(() => {
    fetchPrices();
  }, []);

  const handleAdd = async () => {
    try {
      const { data } = await axios.post("/prices", newPrice);
      setPrices([...prices, data]);
      setNewPrice({});
    } catch (err) {
      console.error("Помилка при додаванні", err);
    }
  };

  const handleEdit = (id) => setEditingId(id);

  const handleSave = async (id) => {
    try {
      await axios.patch(
        `/prices/${id}`,
        prices.find((p) => p._id === id)
      );
      setEditingId(null);
    } catch (err) {
      console.error("Помилка при збереженні", err);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`/prices/${id}`);
      fetchPrices();
    } catch (err) {
      console.error("Помилка при видаленні", err);
    }
  };

  const handleImageUpload = async (e, id) => {
    try {
      const formData = new FormData();
      formData.append("image", e.target.files[0]);
      const { data } = await axios.post("/upload", formData);

      setPrices(
        prices.map((p) => (p._id === id ? { ...p, imageUrl: data.url } : p))
      );
    } catch (err) {
      console.error("Помилка завантаження зображення", err);
    }
  };

  return (
    <TableContainer
      component={Paper}
      sx={{
        ...(isMobile && {
          width: "100vw",
          marginLeft: "calc(-50vw + 50%)",
          overflow: "auto",
        }),
      }}
    >
      {isAdmin && (
        <div style={{ padding: "16px" }}>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleAdd}
          >
            Додати рядок
          </Button>
        </div>
      )}

      <Table sx={{ minWidth: isMobile ? "100%" : 650 }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontSize: isMobile ? "0.85rem" : "inherit" }}>
              Назва
            </TableCell>
            <TableCell sx={{ fontSize: isMobile ? "0.85rem" : "inherit" }}>
              Зображення
            </TableCell>
            <TableCell sx={{ fontSize: isMobile ? "0.85rem" : "inherit" }}>
              Ціна(грн)
            </TableCell>
            <TableCell sx={{ fontSize: isMobile ? "0.85rem" : "inherit" }}>
              Посилання на пост
            </TableCell>
            {isAdmin && (
              <TableCell sx={{ fontSize: isMobile ? "0.85rem" : "inherit" }}>
                Дії
              </TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {prices.map((price) => (
            <TableRow key={price._id}>
              <TableCell
                sx={{
                  padding: isMobile ? "8px" : "16px",
                  fontSize: isMobile ? "0.85rem" : "inherit",
                }}
              >
                {editingId === price._id ? (
                  <TextField
                    value={price.name}
                    onChange={(e) =>
                      setPrices(
                        prices.map((p) =>
                          p._id === price._id
                            ? { ...p, name: e.target.value }
                            : p
                        )
                      )
                    }
                  />
                ) : (
                  price.name
                )}
              </TableCell>

              <TableCell sx={{ padding: isMobile ? "8px" : "16px" }}>
                {price.imageUrl && (
                  <img
                    src={price.imageUrl}
                    alt={price.name}
                    style={{ height: 50 }}
                  />
                )}
                {isAdmin && editingId === price._id && (
                  <input
                    accept="image/*"
                    type="file"
                    onChange={(e) => handleImageUpload(e, price._id)}
                  />
                )}
              </TableCell>

              <TableCell
                sx={{
                  padding: isMobile ? "8px" : "16px",
                  fontSize: isMobile ? "0.85rem" : "inherit",
                }}
              >
                {editingId === price._id ? (
                  <TextField
                    type="number"
                    value={price.price}
                    onChange={(e) =>
                      setPrices(
                        prices.map((p) =>
                          p._id === price._id
                            ? { ...p, price: e.target.value }
                            : p
                        )
                      )
                    }
                  />
                ) : (
                  `${price.price} грн`
                )}
              </TableCell>

              <TableCell
                sx={{
                  padding: isMobile ? "8px" : "16px",
                  fontSize: isMobile ? "0.85rem" : "inherit",
                }}
              >
                {editingId === price._id ? (
                  <TextField
                    value={price.postLink}
                    onChange={(e) =>
                      setPrices(
                        prices.map((p) =>
                          p._id === price._id
                            ? { ...p, postLink: e.target.value }
                            : p
                        )
                      )
                    }
                  />
                ) : (
                  <a
                    href={price.postLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Перейти до поста
                  </a>
                )}
              </TableCell>

              {isAdmin && (
                <TableCell sx={{ padding: isMobile ? "4px" : "16px" }}>
                  {editingId === price._id ? (
                    <IconButton
                      size={isMobile ? "small" : "medium"}
                      onClick={() => handleSave(price._id)}
                    >
                      <SaveIcon />
                    </IconButton>
                  ) : (
                    <IconButton
                      size={isMobile ? "small" : "medium"}
                      onClick={() => handleEdit(price._id)}
                    >
                      <EditIcon />
                    </IconButton>
                  )}
                  <IconButton
                    size={isMobile ? "small" : "medium"}
                    onClick={() => handleDelete(price._id)}
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
